module.exports = __webpack_public_path__ + "img/card_at_referrals.4a14d3f8.svg";